import request from "@/util/request";
import util from "@/util/util";
class question {
  /**帮助中心菜单列表 */
  menulist(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.help.menulist",
          data: {
            client_type: self.$route.name == 'questionpcList' ? 3 : 1,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**帮助中心问题列表 */
  titlelist(self,id) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.help.menu.titlelist",
          data: {
            // account_id: util.getCookie("account_id"),
            help_menu_id:id
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**帮助中心问题内容 */
  content(self,id) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.help.menu.content",
          data: {
            // account_id: util.getCookie("account_id"),
            help_content_id:id
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**帮助中心相关问题 */
  keywordQuery(self,keyword) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.help.content.correlate",
          data: {
            key_word:keyword,
            client_type: self.$route.name == 'questionpcList' ? 3 : 1,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**帮助中心赞或踩 */
  gather(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.help.question.gather",
          data: {
            help_content_id:self.queryId,
            status:self.status,
            remark:self.remark,
            // account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**帮助中心问题模糊搜索 */
  query(self,data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.help.content.query",
          data: {
            key_word: data,
            client_type: self.$route.name == 'questionpcList' ? 3 : 1,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**banner图*/
  bannerList(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.banners",
          data: {
            type:1,
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }  
  /**站内信列表查询*/
  getAccountMessageList(action,data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: action,
          data: data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**站内信详情查询*/
  getMessageContent(self,data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.message.getMessageContent",
          data: data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**站内信标为已读*/
  updateReadStatus(self,data) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.message.updateReadStatus",
          data: data
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
}
export default new question();